var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueMarkdownEditor',{attrs:{"height":"400px"},model:{value:(_vm.markdownText),callback:function ($$v) {_vm.markdownText=$$v},expression:"markdownText"}})
}
var staticRenderFns = []

export { render, staticRenderFns }